const store = {
    page: 0
};
export default store;
